import classes from "./HowItWorks.module.css";

const list = [
  {
    title: "Funded by Challenge Fees",
    desc: "50% of all challenge fees are directly allocated to the Community Withdrawal Pool. This ensures a sustainable and transparent source for trader payouts.",
  },
  {
    title: "Backed by Initial Reserves",
    desc: "The pool is initialized with company reserves, providing a solid foundation of liquidity to support early payouts and build trust within the trading community.",
  },
  {
    title: "Sustainable Payouts for Traders",
    desc: "All trader withdrawals are processed exclusively through the pool, ensuring that profits are distributed fairly and transparently without additional overhead. A 10% monthly cap per trader prevents the pool from draining.",
  },
  {
    title: "Built for Transparency and Trust",
    desc: "The Community Withdrawal Pool is publicly trackable, with clear metrics showing contributions, payouts, and remaining funds. This guarantees fairness and accountability for all participants",
  },
];

const HowItWorks = ({className}) => {
  return (
    <div className={`row mx-0 ${classes.wrapper} ${className}`}>
      <div className={`${classes.payoutPool} col-md-6`}>
        <div className={classes.infoText}>
          <h4>What Is the Community Payout Pool?</h4>
          <p>
            The Community Payout Pool is a transparent trackable fund powered by
            50% of challenge fees and initially seeded with company reserves,
            ensuring fair and sustainable payouts for all traders.
          </p>
        </div>
        <img src="/images/men-working.svg" />
      </div>
      <div className="col-md-6">
        <ul className={classes.infoList}>
          {list.map((item, i) => (
            <li key={i}>
              <h6>{item.title}</h6> <p>{item.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HowItWorks
